export default __webpack_public_path__ + "static/media/share.f39706f5.svg";